////////LIBRARY/////////
import React, { useEffect, useState, Fragment, useRef } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useForm } from 'react-hook-form'
import { rolesManagerActionCreators } from '../../store/actions'
import { bindActionCreators } from 'redux'
import { cloneDeep, map, isUndefined, isEmpty, find, filter, reject, includes, range } from 'lodash'
///////COMPONENTS///////
import styled from 'styled-components'
import {
	PageWrapper,
	PageTitle,
	PageWrapperActions,
	PageWrapperActionReset,
	PageWrapperActionValidate,
	PageWrapperGrids,
	TextModal,
	ButtonWrapper,
	InputWrapper,
	InputLogin,
	SelectInputWrapper,
	ErrorInputFlex,
	ErrorInputMsg,
	PageGridTitle,
	SelectInputCustom,
	OptionCustom,
} from '../../theme/GlobalCss'
import RolesListManager from './RolesListManager'
import RolesListUserManager from './RolesListUserManager'
import RolesPrivilegesManager from './RolesPrivilegesManager'
import Tooltip from '../../components/Tooltip/Tooltip'
import Button from '../../components/Ui/Buttons'
import Modals from '../../components/Modals'
import ImgButton from '../../components/Ui/ImgButton'
import theme from '../../theme/theme'
import userPrivileges from '../../constants/PrivilegesList'
/////////ASSETS/////////
import CloseButtonIcon from '../../assets/icones/global/close-white.svg'
import ValidateButtonIcon from '../../assets/icones/global/check.svg'

//////STYLED//////
const PageGridOverflow = styled.div`
	overflow-y: scroll;
	max-height: 50vh;
`
const RolesManagerWrapper = styled.div`
	position: relative;
`
const RolesManagerModalCreateWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
	& > * {
		margin: 10px 5px;
	}
	width: 410px;
`
const RolesManagerRecapWrapper = styled.div`
	display: flex;
	& > div:nth-child(2) {
		border-left: 1px solid ${(props) => props.theme.colors.listNav.border};
		margin-left: 11px;
	}
`
const RolesManagerRecap = styled.div`
	display: flex;
	justify-content: space-between;
	& > div {
		width: 50%;
	}
`
const RecapItem = styled.div`
	padding: 10px 11px;
	display: flex;
	align-items: center;
`
const RecapItemInput = styled.input`
	margin: 0px 19px 0px 0px;
`
const RecapItemLabel = styled.label`
	color: ${(props) => (props.foundInList ? props.theme.text.colors.primary : props.theme.colors.error)};
	text-decoration-line: ${(props) => (props.foundInList ? 'none' : 'line-through')};
`
const TextModalCustom = styled(TextModal)`
	max-height: ${(props) => (props.userMode ? '500px' : '600px')};
	overflow-y: ${(props) => (props.overflow ? 'scroll' : '')};
`
//////STYLED//////

const RolesManager = (props) => {
	const [stateDefaultValuesModal, setStateDefaultValuesModal] = useState({
		roleName: '',
	})

	const [modalCreateMode, setModalCreateMode] = useState(true)
	const [showModal, setShowModal] = useState(false)
	const [showDeleteModal, setShowDeleteModal] = useState(false)
	const [showModalRecap, setShowModalRecap] = useState(false)
	const [showPrivilegesRecap, setShowPrivilegesRecap] = useState(false)

	const [listIdSelected, setListIdSelected] = useState([])

	const [listPrivileges, setListPrivileges] = useState([]) // All privileges selected by user
	const [foundPrivileges, setFoundPrivileges] = useState() // Privileges found when back was called
	const [listUsers, setListUsers] = useState([]) // All users selected by user
	const [foundUsers, setFoundUsers] = useState() // Users found when back was called
	const [recapListPrivileges, setRecapListPrivileges] = useState([]) // All privileges selected by user on modal

	const [modalListUsers, setModalListUsers] = useState([])
	const [modalListPrivileges, setModalListPrivileges] = useState([])

	const listRef = useRef()

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleListUsers = (list) => {
		setListUsers(list)
	}

	const handleListPrivileges = (list) => {
		setListPrivileges(list)
	}

	const handleModal = (dataRow) => {
		!isUndefined(dataRow) ? setModalCreateMode(false) : setModalCreateMode(true)
		setShowModal((prevState) => !prevState)
	}

	const handleDeleteModal = (_dataRow) => {
		setShowDeleteModal((prevState) => !prevState)
	}

	const handleModalRecap = (_dataRow) => {
		if (!isUndefined(listIdSelected) && (!props.userMode || (props.userMode && rolesManager.roleDetail.role.canBeModify)))
			setShowModalRecap((prevState) => !prevState)
	}

	const handlePrivilegesRecap = () => {
		// We make sure that edited privileges list is reset
		if (showPrivilegesRecap) setRecapListPrivileges(listPrivileges)
		if (!isUndefined(listIdSelected)) setShowPrivilegesRecap((prevState) => !prevState)
	}

	const { translations, rolesManager, userRoleLvl, userRolePrivileges } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			rolesManager: state.rolesManager,
			userRoleLvl: state.user.identity.rolePrivileges.role.level,
			userRolePrivileges: state.user.identity.rolePrivileges,
		}),
		shallowEqual
	)

	const actionsRolesManager = bindActionCreators(rolesManagerActionCreators, useDispatch())

	const {
		register: registerModal,
		handleSubmit: handleSubmitModal,
		watch,
		errors: errorsModal,
		setValue: setValueModal,
		getValues: getValuesModal,
	} = useForm({
		defaultValues: stateDefaultValuesModal,
	})

	const { register: registerModalRecap, handleSubmit: handleSubmitModalRecap, errors: errorsModalRecap, setValue: setValueModalRecap } = useForm()

	const { register: registerModalRecapPrivileges, handleSubmit: handleSubmitModalRecapPrivileges } = useForm()

	const onSubmit = (data) => {
		let datas = cloneDeep(data)
		// Users are no longer required
		// So are privileges
		if (data.users.length > 0) datas.users = data.users.split(',')
		datas.privileges = data.privileges.length > 0 ? data.privileges.split(',') : []

		actionsRolesManager.updateContentRole(listIdSelected[0], datas)
		handleModalRecap()
	}

	const onSubmitHeader = (data) => {
		let datas = cloneDeep(data)
		if (modalCreateMode) {
			actionsRolesManager.createRole(datas)
			handleModal()
		} else {
			if (rolesManager.roleDetail !== false) {
				actionsRolesManager.updateHeaderRole(listIdSelected[0], datas)
				handleModal()
			}
		}
	}

	const onSubmitRecapPrivileges = (datas) => {
		datas.privileges = datas.privileges.split(',')
		let arr = []
		map(datas.privileges, (elem) => {
			return arr.push(parseInt(elem))
		})
		setListPrivileges(arr)
		handlePrivilegesRecap()
	}

	const handlePrivilegesRecapChecks = (selectedId, isChecked) => {
		let newListSelected = cloneDeep(recapListPrivileges)
		const rowFound = find(recapListPrivileges, (o) => o === selectedId) ? true : false
		if (!rowFound && !isChecked) {
			newListSelected.push(selectedId)
		}
		if (rowFound && isChecked) {
			newListSelected = reject(newListSelected, (o) => o === selectedId)
		}
		setRecapListPrivileges(newListSelected)
	}

	const handleValidationRecapUsersChecks = (selectedId, isChecked) => {
		let newListSelected = cloneDeep(modalListUsers)
		const rowFound = find(modalListUsers, (o) => o === selectedId) ? true : false
		if (!rowFound && !isChecked) {
			newListSelected.push(selectedId)
		}
		if (rowFound && isChecked) {
			newListSelected = reject(newListSelected, (o) => o === selectedId)
		}
		setModalListUsers(newListSelected)
	}

	const handleValidationRecapPrivilegesChecks = (selectedId, isChecked) => {
		let newListSelected = cloneDeep(modalListPrivileges)
		const rowFound = find(modalListPrivileges, (o) => o === selectedId) ? true : false
		if (!rowFound && !isChecked) {
			newListSelected.push(selectedId)
		}
		if (rowFound && isChecked) {
			newListSelected = reject(newListSelected, (o) => o === selectedId)
		}
		setModalListPrivileges(newListSelected)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (!isUndefined(listIdSelected)) {
			if (isUndefined(listRef.current) || listIdSelected[0] !== listRef.current[0]) {
				if (!isEmpty(listIdSelected)) actionsRolesManager.getRoleDetail(listIdSelected[0])
			}
		}
		listRef.current = listIdSelected
	}, [listIdSelected])

	useEffect(() => {
		if (rolesManager.roleDetail !== false) {
			setValueModalRecap('privileges', listPrivileges)
			setValueModalRecap('users', listUsers)

			setRecapListPrivileges(listPrivileges)
			setModalListUsers(listUsers)
			setModalListPrivileges(listPrivileges)
		}
	}, [listUsers, listPrivileges])

	useEffect(() => {
		if (rolesManager.roleDetail !== false && showModal && !modalCreateMode) {
			setValueModal('roleName', rolesManager.roleDetail.role.label)
			setValueModal('level', rolesManager.roleDetail.role.level)
			setStateDefaultValuesModal(getValuesModal)
		}
	}, [showModal])

	useEffect(() => {
		rolesManager.roleDetail !== false && setFoundPrivileges(filter(rolesManager.roleDetail.privileges, (o) => o.isSelected))
		rolesManager.roleDetail !== false && setFoundUsers(filter(rolesManager.roleDetail.users, (o) => o.selected))
		setRecapListPrivileges(rolesManager.roleDetail.privileges?.filter((o) => o.isSelected).map((elem) => elem.id))
	}, [rolesManager.roleDetail])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			<Modals
				title={translations['modal__roleManagement__delete_placeholder']}
				closeModalHandler={handleDeleteModal}
				showModal={showDeleteModal}
				insideModal={!isUndefined(props.userMode)}
				level="error"
				icon={true}
			>
				<TextModal>
					<p>{translations['modal__roleManagement__delete_warning']}</p>
				</TextModal>
				<ButtonWrapper>
					<Button
						actionHandler={handleDeleteModal}
						text={translations['common__text__cancel']}
						bgColor={theme.colors.error}
						margin="true"
						img={CloseButtonIcon}
					/>

					<Button
						actionHandler={() => {
							actionsRolesManager.deleteRole(rolesManager.roleDetail.role.id)
							handleDeleteModal()
						}}
						text={translations['common__text__delete']}
						bgColor={theme.colors.validation}
						img={ValidateButtonIcon}
					/>
				</ButtonWrapper>
			</Modals>
			<Modals
				title={
					modalCreateMode
						? translations['modal__roleManagement__create_placeholder']
						: translations['modal__roleManagement__edit_placeholder']
				}
				closeModalHandler={handleModal}
				showModal={showModal}
				icon={true}
				insideModal={!isUndefined(props.userMode)}
			>
				<form onSubmit={handleSubmitModal(onSubmitHeader)}>
					<TextModal>
						<RolesManagerModalCreateWrapper>
							<p>
								{modalCreateMode
									? translations['modal__roleManagement__newRole']
									: translations['modal__roleManagement__edit_message']}
							</p>
							<InputWrapper>
								<InputLogin
									name="roleName"
									type="text"
									placeholder={translations['modal__roleManagement__create_name']}
									ref={registerModal({
										required: {
											value: true,
											message: translations['common__text__requiredField'],
										},
										maxLength: {
											value: 150,
											message: '',
										},
									})}
								/>
								{errorsModal.roleName && <ErrorInputMsg>{errorsModal.roleName.message}</ErrorInputMsg>}
							</InputWrapper>
							<InputWrapper>
								<SelectInputWrapper blueColor>
									<SelectInputCustom
										name="level"
										className={watch('level') > 0 ? 'active' : ''}
										ref={registerModal({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
											validate: (value) => value > 0 || translations['common__text__requiredField'],
										})}
									>
										<OptionCustom value="0" hidden>
											{' '}
											{translations['modal__roleManagement__create_level']}
										</OptionCustom>
										{
											// Juste for mapping level, one to ten
											map(range(userRoleLvl, 11, 1), (elem, _id) => {
												return (
													<OptionCustom key={elem} value={elem} target={true}>
														{translations['modal__roleManagement__create_level']} {elem}
													</OptionCustom>
												)
											})
										}
									</SelectInputCustom>
								</SelectInputWrapper>
								{errorsModal.level && <ErrorInputMsg>{errorsModal.level.message}</ErrorInputMsg>}
							</InputWrapper>
						</RolesManagerModalCreateWrapper>
					</TextModal>
					<ButtonWrapper>
						<Button
							actionHandler={handleModal}
							text={translations['common__text__cancel']}
							bgColor={theme.colors.error}
							margin="true"
							img={CloseButtonIcon}
						/>

						<Button
							text={translations['common__text__validate']}
							bgColor={theme.colors.validation}
							img={ValidateButtonIcon}
							actionHandler={handleSubmitModal(onSubmitHeader)}
						/>
					</ButtonWrapper>
				</form>
			</Modals>
			<Modals
				title={translations['modal__roleManagement__validation_header']}
				closeModalHandler={handleModalRecap}
				showModal={showModalRecap}
				insideModal={!isUndefined(props.userMode)}
				icon={true}
			>
				<form onSubmit={handleSubmitModalRecap(onSubmit)}>
					<input
						name="users"
						type="hidden"
						ref={registerModalRecap({
							required: { value: false },
						})}
						value={listUsers}
					/>
					<input
						name="privileges"
						type="hidden"
						ref={registerModalRecap({
							required: { value: false },
						})}
						value={listPrivileges}
					/>
					<TextModal>
						{rolesManager.roleDetail !== false && showModalRecap && (
							<RolesManagerRecapWrapper>
								<RolesManagerRecap>
									<div>
										<PageGridTitle>
											{translations['modal__roleManagement__validation_existing_privilege']} "
											{rolesManager.roleDetail.role.label}"
										</PageGridTitle>
										<PageGridOverflow>
											{map(foundPrivileges, (item, _id) => {
												const foundInList = find(listPrivileges, (o) => o === item.id) ? true : false
												const foundinCurrentList = includes(modalListPrivileges, item.id)
												return (
													<RecapItem>
														<RecapItemInput
															type="checkbox"
															checked={foundinCurrentList}
															onClick={() => {
																if (rolesManager.roleDetail.role.canBeModify)
																	handleValidationRecapPrivilegesChecks(item.id, foundinCurrentList)
															}}
														></RecapItemInput>
														<RecapItemLabel foundInList={foundinCurrentList}>
															{translations[item.translationKey]}
														</RecapItemLabel>
													</RecapItem>
												)
											})}
										</PageGridOverflow>
									</div>
									<div>
										<PageGridTitle>
											{translations['modal__roleManagement__validation_selected_privilege']} "
											{rolesManager.roleDetail.role.label}"
										</PageGridTitle>
										<PageGridOverflow>
											{map(rolesManager.roleDetail.privileges, (item, _id) => {
												// Check if we have selected item
												const foundInList = find(listPrivileges, (o) => o === item.id) ? true : false
												const foundinCurrentList = includes(modalListPrivileges, item.id)
												// But also check if item was not selected in first place
												return item.isSelected === false && foundInList ? (
													<RecapItem>
														<RecapItemInput
															type="checkbox"
															defaultChecked={true}
															onClick={() => {
																handleValidationRecapPrivilegesChecks(item.id, foundinCurrentList)
															}}
														></RecapItemInput>
														<RecapItemLabel foundInList={foundinCurrentList}>
															{translations[item.translationKey]}
														</RecapItemLabel>
													</RecapItem>
												) : null
											})}
										</PageGridOverflow>
									</div>
								</RolesManagerRecap>
								{!props.userMode && (
									<RolesManagerRecap>
										<div>
											<PageGridTitle>
												{translations['modal__roleManagement__validation_existing_user']} "
												{rolesManager.roleDetail.role.label}"
											</PageGridTitle>
											<PageGridOverflow>
												{
													// We cannot uncheck existing users anymore
													map(foundUsers, (item, _id) => {
														const foundInList = find(listUsers, (o) => o === item.id) ? true : false
														return (
															<RecapItem>
																<RecapItemInput type="checkbox" checked={foundInList}></RecapItemInput>
																<RecapItemLabel foundInList={foundInList}>{item.fullName}</RecapItemLabel>
															</RecapItem>
														)
													})
												}
											</PageGridOverflow>
										</div>
										<div>
											<PageGridTitle>
												{translations['modal__roleManagement__validation_selected_user']} "
												{rolesManager.roleDetail.role.label}"
											</PageGridTitle>
											<PageGridOverflow>
												{map(rolesManager.roleDetail.users, (item, _id) => {
													// Check if we have selected item
													const foundInList = find(listUsers, (o) => o === item.id) ? true : false
													const foundinCurrentList = includes(modalListUsers, item.id)
													// But also check if item was not selected in first place
													return item.selected === false && foundInList ? (
														<RecapItem>
															<RecapItemInput
																type="checkbox"
																onClick={() => {
																	handleValidationRecapUsersChecks(item.id, foundinCurrentList)
																}}
																defaultChecked={true}
															></RecapItemInput>
															<RecapItemLabel foundInList={foundinCurrentList}>{item.fullName}</RecapItemLabel>
														</RecapItem>
													) : null
												})}
											</PageGridOverflow>
										</div>
									</RolesManagerRecap>
								)}
							</RolesManagerRecapWrapper>
						)}
						{(errorsModalRecap.privileges || errorsModalRecap.users) && (
							<ErrorInputFlex>
								<ErrorInputMsg>{!isUndefined(errorsModalRecap.privileges) ? errorsModalRecap.privileges.message : ''}</ErrorInputMsg>
								<ErrorInputMsg>{!isUndefined(errorsModalRecap.users) ? errorsModalRecap.users.message : ''}</ErrorInputMsg>
							</ErrorInputFlex>
						)}
					</TextModal>
					<ButtonWrapper>
						<Button
							actionHandler={handleModalRecap}
							text={translations['common__text__cancel']}
							bgColor={theme.colors.error}
							margin="true"
							img={CloseButtonIcon}
						/>

						<Button
							text={translations['common__text__validate']}
							bgColor={theme.colors.validation}
							img={ValidateButtonIcon}
							actionHandler={handleSubmitModalRecap(onSubmit)}
						/>
					</ButtonWrapper>
				</form>
			</Modals>
			<Modals
				title={translations['modal__roleManagement__privilegeSummary_header']}
				closeModalHandler={handlePrivilegesRecap}
				showModal={showPrivilegesRecap}
				insideModal={!isUndefined(props.userMode)}
				//maxHeight={600}
				icon={true}
			>
				<form onSubmit={handleSubmitModalRecapPrivileges(onSubmitRecapPrivileges)}>
					<input name="privileges" type="hidden" ref={registerModalRecapPrivileges()} value={recapListPrivileges} />
					<TextModalCustom userMode={props.userMode} overflow={foundPrivileges?.length > 0 ? true : false}>
						{rolesManager.roleDetail.role !== false && showPrivilegesRecap && (
							<RolesManagerRecapWrapper>
								<RolesManagerRecap>
									<div>
										<PageGridTitle>
											{translations['modal__roleManagement__validation_existing_privilege']} "
											{rolesManager.roleDetail.role.label}"
										</PageGridTitle>
										<PageGridOverflow>
											{map(foundPrivileges, (item, _id) => {
												const foundinCurrentList = includes(recapListPrivileges, item.id)
												return (
													<RecapItem>
														<RecapItemInput
															type="checkbox"
															checked={foundinCurrentList}
															disabled={!rolesManager.roleDetail.role.canBeModify}
															onClick={() => {
																handlePrivilegesRecapChecks(item.id, foundinCurrentList)
															}}
														></RecapItemInput>
														<RecapItemLabel foundInList={foundinCurrentList}>
															{translations[item.translationKey]}
														</RecapItemLabel>
													</RecapItem>
												)
											})}
										</PageGridOverflow>
									</div>
									<div>
										<PageGridTitle>
											{translations['modal__roleManagement__validation_selected_privilege']} "
											{rolesManager.roleDetail.role.label}"
										</PageGridTitle>
										<PageGridOverflow>
											{map(rolesManager.roleDetail.privileges, (item, _id) => {
												const foundInList = includes(listPrivileges, item.id)
												const foundinCurrentList = includes(recapListPrivileges, item.id)
												return foundInList && !item.isSelected ? (
													<RecapItem>
														<RecapItemInput
															type="checkbox"
															checked={foundinCurrentList}
															disabled={!rolesManager.roleDetail.role.canBeModify}
															onClick={() => {
																handlePrivilegesRecapChecks(item.id, foundinCurrentList)
															}}
														></RecapItemInput>
														<RecapItemLabel foundInList={foundinCurrentList}>
															{translations[item.translationKey]}
														</RecapItemLabel>
													</RecapItem>
												) : null
											})}
										</PageGridOverflow>
									</div>
								</RolesManagerRecap>
							</RolesManagerRecapWrapper>
						)}
					</TextModalCustom>

					{rolesManager.roleDetail !== false && rolesManager.roleDetail.role.canBeModify === true && (
						<ButtonWrapper>
							<Button
								actionHandler={handlePrivilegesRecap}
								text={translations['common__text__cancel']}
								bgColor={theme.colors.error}
								margin="true"
								img={CloseButtonIcon}
							/>

							<Button
								text={translations['common__text__validate']}
								bgColor={theme.colors.validation}
								img={ValidateButtonIcon}
								actionHandler={handleSubmitModalRecapPrivileges(onSubmitRecapPrivileges)}
							/>
						</ButtonWrapper>
					)}
				</form>
			</Modals>
			<RolesManagerWrapper>
				<PageWrapper>
					<PageTitle>{translations['page__roleManagement__roleSheet_edit']}</PageTitle>
					<PageWrapperActions absolute>
						<>
							<Tooltip tooltipId={'roleSubmit'} translationsKey={'tooltip__admin__global__save'}>
								<PageWrapperActionValidate
									unlocked={!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[11]))}
									onClick={() =>
										!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[11]))
											? handleModalRecap()
											: null
									}
								/>
							</Tooltip>
							{props.userMode && (
								<ImgButton
									img={CloseButtonIcon}
									action={() => props.closeModalHandler()}
									color={theme.colors.error}
									margin={'5px'}
									hover={theme.colors.hoverError}
								/>
							)}
							<Tooltip tooltipId={'roleReset'} translationsKey={'tooltip__admin__global__reset'}>
								<PageWrapperActionReset onClick={() => actionsRolesManager.resetRole()} />
							</Tooltip>
						</>
					</PageWrapperActions>
					<PageWrapperGrids grids={3}>
						<RolesListManager
							showCreationModal={handleModal}
							showDeleteModal={handleDeleteModal}
							listSelected={setListIdSelected}
							keepSelected
							ref={listRef}
							userMode={!!props.userMode}
						/>
						{
							// Si le role est modifiable
							// si je n'ai pas le droit
							// Donc si je peux modifier le rol
							!isUndefined(rolesManager.roleDetail.privileges) && (
								<RolesPrivilegesManager
									readOnly={
										!rolesManager.roleDetail.role.canBeModify ||
										rolesManager.roleDetail.role?.new ||
										isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[11]))
									}
									setPrivilegesList={handleListPrivileges}
									showRecap={handlePrivilegesRecap}
									recapList={listPrivileges}
									userMode={!!props.userMode}
								/>
							)
						}
						{!isUndefined(rolesManager.roleDetail.users) && (
							<RolesListUserManager
								setUserList={handleListUsers}
								readOnly={
									!!props.userMode || isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[11]))
								}
								recapList={listUsers}
							/>
						)}
					</PageWrapperGrids>
				</PageWrapper>
			</RolesManagerWrapper>
		</Fragment>
	)
}

RolesManager.propTypes = {}

RolesManager.defaultPropTypes = {}

export default RolesManager
